import { Outlet } from "react-router-dom";

import { Container } from "./Authentication.styles";

const Authentication = () => {
  return (
    <Container>
      <main>
        <Outlet />
      </main>
    </Container>
  );
};

export default Authentication;
